export function start() {
  document.addEventListener("turbolinks:load", () => {
    Turbolinks.BrowserAdapter.prototype.showProgressBarAfterDelay = function() {
      return (this.progressBarTimeout = setTimeout(this.showProgressBar, 0));
    }
  })
}
